const BASE_URL = 'https://dashboardetudejointeffort.ca';

const API_PREFIX = 'api/v1';

export const API_URL = `${BASE_URL}/${API_PREFIX}`;

export const DOCUMENTS_URL: { PRIVACY_POLICY_URL: string } = {
    PRIVACY_POLICY_URL: `https://dashboardetudejointeffort.ca/assets/politique-confidentialite.pdf`,
};
